// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","loader__wheel":"Loader_loader__wheel__IY3Bb","spinner":"Loader_spinner__wDq1e","loader__text":"Loader_loader__text__OeAno"};